export const CONSTANTS = {
  ru: {
    breadcrumbs: ['Корзина']
  },
  uk: {
    breadcrumbs: ['Кошик']
  }
};